export type SortDirection = 'ASC' | 'DESC';

export function by<T>(key: keyof T, direction: SortDirection = 'ASC'): (a: T, b: T) => number {
  let largerThan = 1;
  let smallerThan = -1;

  if (direction === 'DESC') {
    largerThan = negate(largerThan);
    smallerThan = negate(smallerThan);
  }

  return (a, b) => (a[key] > b[key] ? largerThan : smallerThan);
}

function negate(n: number): number {
  return -n;
}

export const filterStringPropertiesByValue = <T>(arr: T[], filterValue: string) => {
  return arr.filter(item => {
    return Object.keys(item).some(key => {
      const propertyValue = item[key];
      return (
        typeof propertyValue === 'string' &&
        propertyValue.toLowerCase().includes(filterValue.toLowerCase())
      );
    });
  });
};

export function filterOnlyUnique(value: { id: string }, index: number, self: { id: string }[]) {
  return index === self.findIndex(t => t.id === value.id);
}

export function sum(arr: number[]): number {
  return arr.reduce((curr, acc) => (acc += curr), 0);
}

export function arrayFromEnum(en: object, excludeZero = true): number[] {
  const arr = Object.values(en).filter(v => typeof v === 'number') as number[];

  if (excludeZero) {
    return arr.filter(i => i !== 0);
  }

  return arr;
}

/**
 * Groups all items in an array of objects `T` where the value of property `K` is the same
 * @param array Items to group
 * @param key Key of `T` to group by
 */
export function groupBy<T, K extends keyof T>(array: T[], key: K) {
  const map = new Map<T[K], T[]>();
  array.forEach(item => {
    const itemKey = item[key];
    if (!map.has(itemKey)) {
      map.set(itemKey, array.filter(i => i[key] === item[key]));
    }
  });
  return map;
}
